import styled from "styled-components";

const CustomLabelLarge = styled.div`
  color: var(--elementDim);
  font-size: 19px;
  font-weight: 600;
  text-transform: capitalize;
`;

export default CustomLabelLarge;
